import { BedIcon } from '@jouzen/ecom-components/icons/BedIcon';
import { HeartIcon } from '@jouzen/ecom-components/icons/HeartIcon';
import { HrvIcon } from '@jouzen/ecom-components/icons/HrvIcon';
import { TemperatureIcon } from '@jouzen/ecom-components/icons/TemperatureIcon';
import type { SVGIconComponent } from 'types/svgr';

import type { AccuracyCardProps } from '@/app/components/LandingPage/LandingPageAccuracy/AccuracyCard';

const accuracyCards: AccuracyCardProps[] = [
  {
    heading: 'hra_heading',
    icon: HeartIcon as SVGIconComponent,
    note: 'hra_copy',
    percentage: 0.99,
  },
  {
    heading: 'hrv_heading',
    icon: HrvIcon as SVGIconComponent,
    note: 'hrv_copy',
    percentage: 0.98,
  },
  {
    heading: 'bta_heading',
    icon: TemperatureIcon as SVGIconComponent,
    note: 'bta_copy',
    percentage: 0.92,
  },
  {
    heading: 'sta_heading',
    icon: BedIcon as SVGIconComponent,
    note: 'sta_copy',
    percentage: 0.79,
  },
];

export default accuracyCards;
